import React, { Fragment, useContext, useEffect, useState, useReducer, createContext } from "react";
import { AuthContext } from '../../App/App'
import Dashboard from "./Dashboard/Dashboard";
import Helpdesk from "./Helpdesk/Helpdesk";
import Whatsapp from "./Whatsapp/Whatsapp";
import CustomerServices from "./CustomerServices/CustomerServices";
import Profile from "./Profile/Profile";
import ComplateMessages from "./ComplateMessages/ComplateMessages";
import Contact from "./Contact/Contact";
import WhatsappContact from "./WhatsappContact/WhatsappContact";
import ChatCategory from "./ChatCategory/ChatCategory";
import Message from "./Message/Message";
import jwt from 'jwt-decode'
import MasterAdmin from "./MasterAdmin/MasterAdmin";

export const ContentBodyContext = createContext();

function ContentBody() {
  const { stateAuth, dispatchAuth } = useContext(AuthContext)
  const initialRenderBody = (
    <Fragment />
  )
  const [renderContent, setrenderContent] = useState(initialRenderBody)
  useEffect(() => {
    // if(stateAuth.page)
    switch (stateAuth.page) {
      case "Dashboard":
        return setrenderContent(<Dashboard />)
      case "Message":
        return setrenderContent(<Message />)
      case "Helpdesk Chat":
        return setrenderContent(<Helpdesk />)
      case "WhatsApp Chat":
        return setrenderContent(<Whatsapp />)
      case "Customer Services":
        return setrenderContent(<CustomerServices />)
      case "Profile":
        return setrenderContent(<Profile />)
      case "Completed Messages":
        return setrenderContent(<ComplateMessages />)
      case "Contact":
        return setrenderContent(<Contact />)
      case "Whatsapp Number":
        return setrenderContent(<WhatsappContact />)
      case "Chat Category":
        return setrenderContent(<ChatCategory />)
      case "Master Admin":
        return setrenderContent(<MasterAdmin />)
      default:
        return setrenderContent((Number.isInteger(jwt(localStorage.getItem('token-helpdesk-umy')).role_id) ? <Dashboard /> : <Message />))
    }
  }, [stateAuth.page])

  return (
    <Fragment>
      {renderContent}
    </Fragment >
  )
}

export default ContentBody

